/**
 * Initializes Swiper on "You may also like" when layout uses trending carousel.
 * Recommendations load async into <product-recommendations>; we observe and init once Slides exist.
 */
(() => {
  if (window.__relatedTrendingSwiperInit) return;
  window.__relatedTrendingSwiperInit = true;

  function buildSwiperOptions(el) {
    const slideCount =
      parseInt(el.getAttribute('data-slide-count'), 10) || el.querySelectorAll('.swiper-slide').length;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayEnabled = !prefersReducedMotion && el.getAttribute('data-autoplay') !== 'false';
    const autoplaySpeedSec = parseFloat(el.getAttribute('data-autoplay-speed')) || 6;
    const autoplayDelayMs = Math.max(2000, autoplaySpeedSec * 1000);
    const navRoot = el.closest('.trending-slider');
    const loop = slideCount >= 4;

    const swiperOpts = {
      slidesPerView: 1.5,
      spaceBetween: 16,
      loop: loop,
      speed: 2500,
      grabCursor: true,
      touchRatio: 0.85,
      resistance: true,
      resistanceRatio: 0.7,
      threshold: 8,
      longSwipesRatio: 0.35,
      navigation: navRoot
        ? {
            prevEl: navRoot.querySelector('.trending-slider__arrow--prev'),
            nextEl: navRoot.querySelector('.trending-slider__arrow--next'),
          }
        : {},
      breakpoints: {
        750: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    };

    if (autoplayEnabled && loop) {
      swiperOpts.autoplay = {
        delay: autoplayDelayMs,
        disableOnInteraction: false,
      };
    }

    return { swiperOpts, slideCount };
  }

  function initEl(el) {
    if (!el || el.getAttribute('data-swiper-inited') === '1') return;
    if (typeof Swiper === 'undefined') return;

    const { swiperOpts, slideCount } = buildSwiperOptions(el);
    if (slideCount === 0) return;

    new Swiper(el, swiperOpts);
    el.setAttribute('data-swiper-inited', '1');
  }

  function scanHost(host) {
    host.querySelectorAll('[data-related-trending-swiper]').forEach((node) => initEl(node));
  }

  function observeHost(host) {
    if (host.getAttribute('data-related-trending-obs') !== '1') {
      host.setAttribute('data-related-trending-obs', '1');
      const mo = new MutationObserver(() => scanHost(host));
      mo.observe(host, { childList: true, subtree: true });
    }
    scanHost(host);
  }

  function bindAll() {
    document.querySelectorAll('product-recommendations.related-products').forEach((host) => observeHost(host));
  }

  function kick() {
    bindAll();
  }

  function whenDomReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  whenDomReady(() => {
    kick();
    window.addEventListener('load', kick, { once: true });
  });

  function nodeNeedsBind(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches('product-recommendations.related-products')) return true;
    return Boolean(node.querySelector && node.querySelector('product-recommendations.related-products'));
  }

  const moDoc = new MutationObserver((mutations) => {
    for (let i = 0; i < mutations.length; i++) {
      const added = mutations[i].addedNodes;
      for (let j = 0; j < added.length; j++) {
        if (nodeNeedsBind(added[j])) {
          bindAll();
          return;
        }
      }
    }
  });
  moDoc.observe(document.documentElement, { childList: true, subtree: true });
})();
